import { useMemo } from 'react';
import { createBreakpoint } from 'react-use';
const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536
} as const;
const useBreakpoint = createBreakpoint(breakpoints);
export default () => {
  const breakpoint = useBreakpoint();
  const isMobile = useMemo(() => breakpoint === 'sm' || breakpoint === 'xs', [breakpoint]);
  return {
    breakpoint,
    isMobile
  };
};